import {AUDIT_TRAIL} from '../actions/const';

import moment from 'moment';

const initialState = {
  mode: 'AuditTrailsWeb',
  limit: 10,
  totalRecord: '',
  tableData: [],
  filterUser: null,
  filterModule: null,
  filterAction: null,
  filterStartDate: moment(),
  filterEndDate: moment()
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case AUDIT_TRAIL:
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/AuditTrail.js